import React, { useState } from "react";
import styled from "styled-components";
import { Spacing } from "@glossy";
import { tr } from "@linkfluence/i18n";
import { Locale } from "@linkfluence/models/locale";
import { User } from "@linkfluence/models/user";
import Button from "@ui-kit/button";

interface IProps {
  locale: Locale;
  authentication: User["authentication"];
  onResetPassword: () => void;
}

const Message = styled.p`
  text-align: center;
  margin: ${Spacing.Medium};
`;

const UiKitProfileSecurity = ({
  authentication,
  onResetPassword,
  locale,
}: IProps) => {
  const [hasResetPassword, setHasResetPassword] = useState(false);

  if (authentication.extern) {
    return (
      <Message>
        {tr(locale, "PROFILE::SECURITY::EXTERN::MESSAGE", {
          idp: authentication.idp ?? "",
        })}
      </Message>
    );
  } else {
    return (
      <Message>
        {tr(locale, "PROFILE::SECURITY::INTERN::MESSAGE", {
          idp: authentication.idp ?? "",
        })}
        <br />
        <br />
        <Button
          text={tr(locale, "PROFILE::SECURITY::INTERN::RESET_PASSWORD")}
          isDisabled={hasResetPassword}
          onClick={() => {
            setHasResetPassword(true);
            onResetPassword();
          }}
          variant="primary"
        />
      </Message>
    );
  }
};

export default UiKitProfileSecurity;
